import { render, staticRenderFns } from "./CollectionListItem.vue?vue&type=template&id=45ef6793&scoped=true&"
import script from "./CollectionListItem.vue?vue&type=script&lang=js&"
export * from "./CollectionListItem.vue?vue&type=script&lang=js&"
import style0 from "./CollectionListItem.vue?vue&type=style&index=0&id=45ef6793&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ef6793",
  null
  
)

export default component.exports